import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'search-container',
  templateUrl: './search-container.template.html',
  styleUrls: ['./search-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchContainer extends StaticContainer {
  @Input() meta: any;
  @Input() default: any;

  ngOnInit() {
    this.default = this.coreEffects.getRouteDataAsObservable({}, '/search');
    super.ngOnInit();
  }

  setData(data:any){
    if(data.rows)
    {
      data.rows = [];
    }
    
    this.mobileNavigationService.setData(data);
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/search-container/search-container.component.ts